import React from 'react'
import { useDrag } from 'react-dnd'

import { ITEM_TYPES } from '../Constants'

const Option = ({ country, id }) => {
  const [, drag] = useDrag({
    item: { 
      id: id,
      type: ITEM_TYPES.OPTION 
    },
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    })
  })

  return (
    <div className='option' ref={drag}>
      <div className='option__icon' style={{
        backgroundImage: `url(${country.countryInfo.flag})`
      }}></div>
      <div className='option__main'>
        <p className='option__title'>{country.country}</p>
        <p className='option__subtitle'>{country.continent}</p>
      </div>
    </div>
  )
}

export default Option